import { render, staticRenderFns } from "./AssistantCard.vue?vue&type=template&id=743c553f&scoped=true&"
import script from "./AssistantCard.vue?vue&type=script&lang=ts&"
export * from "./AssistantCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743c553f",
  null
  
)

export default component.exports